import { render, staticRenderFns } from "./daily-clicks-app.vue?vue&type=template&id=823dce12"
import script from "./daily-clicks-app.vue?vue&type=script&lang=js"
export * from "./daily-clicks-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports